import {ChartType as CommonChartType} from 'common/types/reports/bookmark';
import {ChartType, FlowsBookmark} from 'common/report/flows/models/types';
import {DateRange} from 'common/widgets/date-range-picker/models/date-range';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {getMergedBookmarkEventAndCohortFilters} from 'common/report/util/bookmark-overrides';

export const CommonChartTypeToFlowsChartType: {[key: string]: ChartType} = {
  [CommonChartType.Sankey]: ChartType.Sankey,
  [CommonChartType.FlowsTopPaths]: ChartType.Paths,
};

export const FlowsChartTypeToCommonChartType: {[key: string]: CommonChartType} = {
  [ChartType.Sankey]: CommonChartType.Sankey,
  [ChartType.Paths]: CommonChartType.FlowsTopPaths,
};

export function getBookmarkParamsWithOverrides(
  bookmarkParams: FlowsBookmark,
  chartTypeOverride: CommonChartType,
  dateRangeOverride: DateRange,
  additionalFilters: PropertyFilter[],
): FlowsBookmark {
  bookmarkParams = chartTypeOverride
    ? getBookmarkParamsWithChartTypeOverride(bookmarkParams, chartTypeOverride)
    : bookmarkParams;
  bookmarkParams = additionalFilters
    ? getBookmarkParamsWithAdditionalFilters(bookmarkParams, additionalFilters)
    : bookmarkParams;

  const dateRange = dateRangeOverride ? dateRangeOverride.getBookmarkFormat() : bookmarkParams.date_range;

  return {
    ...bookmarkParams,
    date_range: dateRange,
  };
}

export function getBookmarkParamsWithChartTypeOverride(
  bookmarkParams: FlowsBookmark,
  chartTypeOverride: CommonChartType,
): FlowsBookmark {
  if (!CommonChartTypeToFlowsChartType[chartTypeOverride]) {
    throw new Error(`unsupported chart type: ${chartTypeOverride}`);
  }

  return {
    ...bookmarkParams,
    chartType: CommonChartTypeToFlowsChartType[chartTypeOverride],
  };
}

export function getBookmarkParamsWithAdditionalFilters(
  bookmarkParams: FlowsBookmark,
  additionalFilters: PropertyFilter[] | null,
): FlowsBookmark {
  const mergedFilters = getMergedBookmarkEventAndCohortFilters(
    {
      filter_by_event: bookmarkParams.filter_by_event,
      filter_by_cohort: bookmarkParams.filter_by_cohort ? JSON.parse(bookmarkParams.filter_by_cohort) : {},
    },
    additionalFilters || [],
  );

  return {
    ...bookmarkParams,
    filter_by_event: mergedFilters.filter_by_event,
    filter_by_cohort: JSON.stringify(mergedFilters.filter_by_cohort ?? {}),
  };
}
